<template>
  <SelectField
    v-if="isFieldVisible(name)"
    v-bind="$props"
    v-model="role"
    :options="filteredOptions"
  />
</template>

<script lang="ts">
export type RoleFieldProps = Omit<SelectFieldProps, "modelValue"> & {
  options: Record<RoleType, string>[];
};
</script>

<script setup lang="ts">
import { useProductTrialFormContext } from "@/components/forms/product-trial/ProductTrialForm.vue";
import {
  RoleType,
  useContactCaptureContext,
} from "@/components/forms/useContactCapture";
import { computed } from "vue";
import SelectField, { SelectFieldProps } from "./SelectField.vue";

const props = withDefaults(defineProps<RoleFieldProps>(), {
  name: "role",
});

const { role, excludeRoles, isFieldVisible } = useContactCaptureContext();
const productTrialForm = useProductTrialFormContext();

const filteredOptions = computed(() => {
  return props.options.filter((option) => {
    const value =
      typeof option === "string" ? option : option[props.valueKey ?? "value"];
    return (
      !productTrialForm?.excludeRoles.includes(value) &&
      !excludeRoles.value.includes(value as RoleType)
    );
  });
});
</script>
